import React from 'react';
import {
    IonModal,
    IonContent,
    IonButton,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonList,
    IonItem,
    IonCheckbox,
    IonLabel, IonRow, IonCol, IonFooter,
} from '@ionic/react';
import useStore from "../zustand/useStore";
import {actionToGetMatrimonialPostingByFilter} from "../apiHelpers/CommonAction";
import {_getIndianStates, _getReligionOptions} from "../apiHelpers/CommonHelper";

export default function MatrimonialFilterSheetModal({ isOpen, onDidDismiss,filterTypeSelection,setFilterTypeSelection }) {
    const {
        selectedReligion, setSelectedReligion,
        selectedIsMyProfile, setSelectedIsMyProfile,
        selectedAge, setSelectedAge,
        selectedEducation, setSelectedEducation,
        selectedLocation, setSelectedLocation,
        selectedMeritialStatus, setSelectedMeritialStatus,
        selectedHeight, setSelectedHeight,
        selectedManglikStatus, setSelectedManglikStatus,
        resetMatrimonialFilters
    } = useStore();

    const handleApplyMatrimonialFilters = async (
        religion,
        age,
        education,
        location,
        meritialStatus,
        height,
        manglikStatus,
        isMyProfile
    ) => {
        const payload = {};
        if (religion.length > 0) payload.religion = religion;
        if (age > 0) payload.age = age;
        if (education.length > 0) payload.education = education;
        if (location.length > 0) payload.location = location;
        if (meritialStatus.length > 0) payload.meritial_status = meritialStatus;
        if (height > 0) payload.height = height;
        if (manglikStatus.length > 0) payload.manglik_status = manglikStatus;
        payload.me_mode = isMyProfile;

        await actionToGetMatrimonialPostingByFilter(true, payload);
    };

    const handleReligionChange = async (value) => {
        let religions;
        if (selectedReligion.includes(value)) {
            religions = selectedReligion.filter((v) => v !== value);
        } else {
            religions = [...selectedReligion, value];
        }

        setSelectedReligion(religions);
        handleApplyMatrimonialFilters(
            religions,
            selectedAge,
            selectedEducation,
            selectedLocation,
            selectedMeritialStatus,
            selectedHeight,
            selectedManglikStatus,
            selectedIsMyProfile
        );
    };

    const handleAgeChange = async (value) => {
        setSelectedAge(value);
        await handleApplyMatrimonialFilters(
            selectedReligion,
            value,
            selectedEducation,
            selectedLocation,
            selectedMeritialStatus,
            selectedHeight,
            selectedManglikStatus,
            selectedIsMyProfile
        );
    };

    const handleEducationChange = async (value) => {
        let education;
        if (selectedReligion === value) {
            education = ''
        } else {
            education = value;
        }
        setSelectedEducation(education);
        await handleApplyMatrimonialFilters(
            selectedReligion,
            selectedAge,
            education,
            selectedLocation,
            selectedMeritialStatus,
            selectedHeight,
            selectedManglikStatus,
            selectedIsMyProfile
        );
    };

    const handleLocationChange = async (value) => {
        let location;
        if (selectedLocation.includes(value)) {
            location = selectedLocation.filter((v) => v !== value);
        } else {
            location = [...selectedLocation, value];
        }

        setSelectedLocation(location);
        handleApplyMatrimonialFilters(
            selectedReligion,
            selectedAge,
            selectedEducation,
            location,
            selectedMeritialStatus,
            selectedHeight,
            selectedManglikStatus,
            selectedIsMyProfile
        );
    };

    const handleMeritialStatusChange = async (value) => {
        let maritialStatus;
        if (selectedMeritialStatus.includes(value)) {
            maritialStatus = selectedMeritialStatus.filter((v) => v !== value);
        } else {
            maritialStatus = [...selectedMeritialStatus, value];
        }

        setSelectedMeritialStatus(maritialStatus);
        handleApplyMatrimonialFilters(
            selectedReligion,
            selectedAge,
            selectedEducation,
            selectedLocation,
            maritialStatus,
            selectedHeight,
            selectedManglikStatus,
            selectedIsMyProfile
        );
    };

    const handleHeightChange = async (value) => {
        setSelectedHeight(value);
        await handleApplyMatrimonialFilters(
            selectedReligion,
            selectedAge,
            selectedEducation,
            selectedLocation,
            selectedMeritialStatus,
            value,
            selectedManglikStatus,
            selectedIsMyProfile
        );
    };

    const handleManglikStatusChange = async (value) => {
        let manglikStatus;
        if (selectedManglikStatus === value) {
            manglikStatus = ''
        } else {
            manglikStatus = value;
        }
        setSelectedManglikStatus(manglikStatus);
        await handleApplyMatrimonialFilters(
            selectedReligion,
            selectedAge,
            selectedEducation,
            selectedLocation,
            selectedMeritialStatus,
            selectedHeight,
            manglikStatus,
            selectedIsMyProfile
        );
    };

    const handleIsMyProfileChange = async () => {
        let isMyProfile = !selectedIsMyProfile;
        setSelectedIsMyProfile(isMyProfile);
        await handleApplyMatrimonialFilters(
            selectedReligion,
            selectedAge,
            selectedEducation,
            selectedLocation,
            selectedMeritialStatus,
            selectedHeight,
            selectedManglikStatus,
            isMyProfile
        );
    };

    const showApplyButton =
        selectedReligion.length > 0 ||
        selectedIsMyProfile ||
        selectedAge > 0 ||
        selectedEducation.length > 0 ||
        selectedLocation.length > 0 ||
        selectedMeritialStatus.length > 0 ||
        selectedHeight > 0 ||
        selectedManglikStatus.length > 0;



    const handleClearFilters = async () => {
        resetMatrimonialFilters();
        onDidDismiss();
        await actionToGetMatrimonialPostingByFilter(true,{me_mode:false});
    };

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            <IonHeader className="filter_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonTitle className="filter_sheet_header_text">Filter Matches</IonTitle>
                    {(showApplyButton) && (
                        <IonButtons slot="end">
                            <div onClick={handleClearFilters} className="filter_sheet_clear_all_btn">Clear all</div>
                        </IonButtons>
                    )}
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding">
                <div className="filter-content">
                    <div className="filter-menu">
                        <IonList>
                            {[
                                "Religion",
                                "Education",
                                "Location",
                                "Marital Status",
                                "Manglik Status"
                            ].map((item, i) => (
                                <IonItem className={`filter_item_sheet_panel ${filterTypeSelection === item ? 'active' : ''}`} onClick={()=>setFilterTypeSelection(item)} key={i} button lines="none">
                                    {item}
                                </IonItem>
                            ))}
                        </IonList>
                    </div>

                    <div className="filter-options">
                        {(filterTypeSelection === 'Religion') &&
                            <IonList>
                                {_getReligionOptions.map((religionOption) => (
                                    <IonItem className="filter_item_sheet_panel" key={religionOption} lines="none">
                                        <IonCheckbox
                                            slot="start"
                                            checked={selectedReligion.includes(religionOption)}
                                            onIonChange={() => handleReligionChange(religionOption)}
                                        />
                                        <IonLabel>{religionOption}</IonLabel>
                                    </IonItem>
                                ))}
                            </IonList>
                        }

                        {/*{(filterTypeSelection === 'Age Range') &&*/}
                        {/*    <IonList className={"in_mobile_filter_list"}>*/}
                        {/*        <IonRange*/}
                        {/*            min={18}*/}
                        {/*            max={40}*/}
                        {/*            pin*/}
                        {/*            snaps*/}
                        {/*            step={1}*/}
                        {/*            value={selectedAge}*/}
                        {/*            onIonChange={(e) => handleAgeChange(e.detail.value)}*/}
                        {/*        />*/}
                        {/*        <div className="range-labels">*/}
                        {/*            <span>18 yrs</span>*/}
                        {/*            <span>40 yrs</span>*/}
                        {/*        </div>*/}
                        {/*    </IonList>*/}
                        {/*}*/}

                        {(filterTypeSelection === 'Education') &&
                            <IonList>
                                {["Graduate", "Post Graduate", "Doctorate"].map((edu) => (
                                    <IonItem className={"filter_item_sheet_panel"} lines="none" key={edu}>
                                        <IonCheckbox
                                            slot="start"
                                            checked={selectedEducation === edu}
                                            onIonChange={() => handleEducationChange(edu)}
                                        />
                                        <IonLabel>{edu}</IonLabel>
                                    </IonItem>
                                ))}
                            </IonList>
                        }

                        {(filterTypeSelection === 'Location') &&
                            <IonList>
                                {_getIndianStates.map((location) => (
                                    <IonItem className={"filter_item_sheet_panel"} key={location} lines="none">
                                        <IonCheckbox
                                            slot="start"
                                            checked={selectedLocation.includes(location)}
                                            onIonChange={() => handleLocationChange(location)}
                                        />
                                        <IonLabel>{location}</IonLabel>
                                    </IonItem>
                                ))}
                            </IonList>
                        }

                        {(filterTypeSelection === 'Marital Status') &&
                            <IonList>
                                {["Never Married", "Divorced", "Widowed"].map((status) => (
                                    <IonItem className={"filter_item_sheet_panel"} lines="none" key={status}>
                                        <IonCheckbox
                                            slot="start"
                                            checked={selectedMeritialStatus.includes(status)}
                                            onIonChange={() => handleMeritialStatusChange(status)}
                                        />
                                        <IonLabel>{status}</IonLabel>
                                    </IonItem>
                                ))}
                            </IonList>
                        }

                        {/*{(filterTypeSelection === 'Height Range') &&*/}
                        {/*    <IonList className={"in_mobile_filter_list"}>*/}
                        {/*        <IonRange*/}
                        {/*            min={140}*/}
                        {/*            max={200}*/}
                        {/*            pin*/}
                        {/*            snaps*/}
                        {/*            step={1}*/}
                        {/*            value={selectedHeight}*/}
                        {/*            onIonChange={(e) => handleHeightChange(e.detail.value)}*/}
                        {/*        />*/}
                        {/*        <div className="range-labels">*/}
                        {/*            <span>140 cm</span>*/}
                        {/*            <span>200 cm</span>*/}
                        {/*        </div>*/}
                        {/*    </IonList>*/}
                        {/*}*/}

                        {(filterTypeSelection === 'Manglik Status') &&
                            <IonList>
                                {["Manglik", "Non-Manglik"].map((mStatus) => (
                                    <IonItem className={"filter_item_sheet_panel"} lines="none" key={mStatus}>
                                        <IonCheckbox
                                            slot="start"
                                            checked={selectedManglikStatus === mStatus}
                                            onIonChange={() => handleManglikStatusChange(mStatus)}
                                        />
                                        <IonLabel>{mStatus}</IonLabel>
                                    </IonItem>
                                ))}
                            </IonList>
                        }
                    </div>
                </div>
            </IonContent>
            <IonFooter className="job_detail_sheet_footer ion-padding">
                <IonToolbar>
                <IonRow>
                    <IonCol>
                        <IonButton className="close_job_detail_button" expand="block" onClick={onDidDismiss}>Close</IonButton>
                    </IonCol>
                </IonRow>
                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
}
